import { ReactNode } from 'react';
import SubMenu from './SubMenu';

export type CreateBtnDescType = {
	id?: string;
	title: string;
	action: (args: any) => void;
};

export type ToolbarPlaces =
	'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight' | 'footerLeft';

export type RenderToolbarHandler = (
	place: ToolbarPlaces,
	otherProps: any,
) => ReactNode | JSX.Element;

export type ResizeOptionType = {
	min?: number;
	max?: number;
	defaultWidth?: number;
	disabledSize?: number;
	enableSaving?: boolean;
	savingKey?: string;
	/** Запрет изменения размера */
	disableResize?: boolean;
};

export default SubMenu;
